import { PopperProps, Popper, Tooltip } from "@mui/material";
import { Box } from "@mui/system";
import { GridRenderCellParams } from "@mui/x-data-grid-premium";
import { GridApiPremium } from "@mui/x-data-grid-premium/models/gridApiPremium";
import { IAttachmentThumbnail } from "@shared/mirage/core/contracts/IAttachment";
import React, { memo } from "react";

interface DocumentsTablePreviewProps {
    params: GridRenderCellParams<IAttachmentThumbnail>;
    thumbnails: {
        [id: number]: string;
    };
    apiRef: React.MutableRefObject<GridApiPremium>;
}

const DocumentsTablePreview: React.FC<DocumentsTablePreviewProps> = memo(({ params, thumbnails, apiRef }) => {
    const isEven = apiRef.current.state.rows.dataRowIds.findIndex((id) => id === params.row.id) % 2 === 0;
    const className = `documentsTable__preview ${!isEven && "documentsTable__preview--odd"}`;

    if (!thumbnails[params.row.id]) {
        return <></>;
    }

    const imgUrl = `data:image/png;base64,${thumbnails[params.row.id]}`;
    return (
        <div className="documentsTable__previewContainer">
            <div className={className}>
                <Tooltip title={"Preview"} PopperProps={{ itemID: imgUrl }} PopperComponent={PreviewPopper}>
                    <img className="documentsTable__previewImage" src={imgUrl} draggable="false" />
                </Tooltip>
            </div>
        </div>
    );
});

const PreviewPopper = (props: PopperProps) => {
    return (
        <Popper open={props.open} anchorEl={props.anchorEl} style={{ zIndex: 1400 }} placement="bottom" modifiers={[{ name: "flip" }]}>
            <Box sx={{ p: 1 }}>
                <img className="documentsTable__preview documentsTable__preview--big" draggable="false" src={props.itemID} />
            </Box>
        </Popper>
    );
};

export default DocumentsTablePreview;
